export const routes = {
  ADMIN: '/admin',
  ADMIN_COMPANY: '/admin/company',
  ADMIN_COMPANY_EDIT: '/admin/company/:id',
  ADMIN_COMPANY_PERMISSION: '/admin/company/:id/permission',
  ADMIN_COMPANY_PERMISSION_EDIT: '/admin/company/:id/permission/:permissionId',
  ADMIN_CREATE_USER: '/admin/create-user',
  ANALYTICS: '/analytics',
  DEMO: '/d',
  DEMO_ANALYTICS: '/analytics/recording',
  DEMO_LIST: '/minhas-demos',
  DEMOHUB: '/h',
  DEMOHUB_LIST: '/demohubs',
  DEMOHUB_EDITOR: '/demohubs/editor',
  DEMOHUB_EDITOR_NEW: '/demohubs/editor/new',
  DEMOHUB_PREVIEW: '/demohubs/preview',
  DEMOHUB_ANALYTICS: '/analytics/demohub',
  EDIT_FORM: '/formularios/editar',
  EDIT_STORYLINE: '/minhas-storylines/editar',
  FEDERATED_SIGN_IN_CALLBACK: '/sign-in-callback',
  FEEDBACK_FORGOT_PASSWORD: '/esqueci-minha-senha-sucesso',
  FEEDBACK_NEW_PASSWORD: '/nova-senha-sucesso',
  FEEDBACK_NEW_VIEWER_USER_PASSWORD: '/confirmar-usuario-sucesso',
  FORM: '/formularios',
  FORGOT_PASSWORD: '/esqueci-minha-senha',
  HOME: '/',
  HUBSPOT: '/hubspot',
  RDSTATION: '/rdstation',
  INTEGRATIONS: '/integracoes',
  NEW_FORM: '/formularios/nova',
  NEW_PASSWORD: '/nova-senha',
  NEW_USER: '/novo-usuario',
  NEW_AVATAR: '/novo-avatar',
  NEW_VIEWER_USER_PASSWORD: '/confirmar-usuario',
  PIPEDRIVE: '/pipedrive',
  GOOGLE: '/google',
  PREVIEW: '/preview',
  PREVIEW_STORYLINE: '/preview-storyline',
  SALESFORCE: '/salesforce',
  SETUP: '/configuracoes',
  SINGLE_SIGN_IN_CALLBACK: '/sso-callback',
  SLACK: '/slack',
  MAKE: '/make',
  STORYLINE: '/minhas-storylines',
  STORYLINE_ANALYTICS: '/analytics/storyline',
  STORYLINE_PLAYER: '/s',
  TEAM: '/time',
  AVATAR: '/avatar',
  BOT: '/bot',
  NEW_BOT: '/novo-bot',
  BOT_PLAYER: '/b',
  BOT_LEADS: '/bot/leads',
  BOT_LEAD_DETAIL: '/bot/leads/:id',
  API_DOCS: '/docs',
  GUIDE_PLAYER: '/t',
  GUIDE_LIST: '/meus-guias',
  GUIDE_ANALYTICS: '/meus-guias/analytics/guia',
  GUIDE_USER_DETAIL: '/meus-guias/usuarios/:id',
  PREVIEW_GUIDE: '/preview-guide',
  SURVEY_ANALYTICS: '/surveys/analytics/survey',
  NEW_SURVEY: '/surveys/new',
  EDIT_SURVEY: '/surveys/edit',
  SETTINGS: '/configuracoes',
  SELECT_CAPTURE_PURPOSE: '/selecionar-finalidade-captura'
};
